/* Asks for an account at the moment saving stops working without one, rather than
   sending shoppers to an app they may not be able to download. Never blocks a tap
   that can succeed locally; only explains why it will not last. */

(function () {
  var SEEN_KEY = 'gettmi:save-prompt-seen:v1';
  var VISIBLE_MS = 9000;
  var timer = null;

  function root() {
    return document.querySelector('[data-gettmi-save-prompt]');
  }

  function alreadyAsked(key) {
    try {
      var raw = window.sessionStorage.getItem(SEEN_KEY);
      return raw ? JSON.parse(raw).indexOf(key) !== -1 : false;
    } catch (error) {
      return false;
    }
  }

  function remember(key) {
    try {
      var raw = window.sessionStorage.getItem(SEEN_KEY);
      var seen = raw ? JSON.parse(raw) : [];
      if (seen.indexOf(key) === -1) seen.push(key);
      window.sessionStorage.setItem(SEEN_KEY, JSON.stringify(seen));
    } catch (error) {
      /* Private mode simply asks again next time. */
    }
  }

  function hide() {
    var mount = root();
    if (mount) mount.hidden = true;
    window.clearTimeout(timer);
  }

  function show(message, options) {
    var mount = root();
    if (!mount) return false;
    var settings = options || {};
    var key = settings.once;
    if (key && alreadyAsked(key)) return false;
    if (key) remember(key);

    var text = mount.querySelector('[data-gettmi-save-prompt-text]');
    if (text) text.textContent = message;
    mount.hidden = false;
    window.clearTimeout(timer);
    /* Dismisses itself so it never becomes furniture. */
    timer = window.setTimeout(hide, VISIBLE_MS);
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('[data-gettmi-save-prompt-close]')) {
      hide();
      return;
    }
    if (event.target.closest('[data-gettmi-save-prompt-signup]')) {
      hide();
      document.dispatchEvent(new CustomEvent('gettmi:signup-required'));
    }
  });

  document.addEventListener('gettmi:signed-in', hide);

  window.GettmiSavePrompt = { show: show, hide: hide };
})();
